import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import SccRemoteImage from '@/components/SccRemoteImage';
import { TutorialMissionTypeDto } from '@/generated-sources/openapi';
import SpeechBubble from './SpeechBubble';
// 박원 figma 의 hero(visual) frame 사이즈. button/말풍선은 hero PNG 에서 제외됐고
// 클라이언트가 따로 sticky CTA / SpeechBubble layer 로 띄운다.
const DESIGN_WIDTH = 390;
const DESIGN_HEIGHT = 512;
// 윌리 모자 위 hot zone (히든 미션 트리거). figma visual 안 item_hidden 노드의
// hero-local 좌표. stage3b (visual 2003:16476) item_hidden = abs(32644,-724,92.06,57.78)
// → hero-local (146, 277, 92, 58). all_complete (visual 2004:15144) 도 거의 동일.
const HAT_HOT_ZONE = {
    left: 146,
    top: 277,
    width: 92,
    height: 58,
};
// figma `mission_item` group 의 외출템 좌표 → hero-local 변환값. 모든 variant frame
// 에서 동일한 절대 좌표를 사용한다 (박원 시안의 vector 노드 좌표는 stage 별로 같음).
//
// 좌표는 **외출템(아이템 그림) 고정**이지 미션 순서 고정이 아니다. v1/v2 에서 미션
// 순서가 바뀌어도 "돋보기를 누르면 돋보기 미션 카드로" 정확히 라우팅되도록 미션
// 타입을 키로 둔다. UPVOTE_ACCESSIBILITY(v1)와 VIEW_TUTORIAL_IMAGES(v2)는 둘 다
// 돋보기이고 한 셋에 동시 등장하지 않으므로 같은 좌표를 공유한다.
const MISSION_ITEM_HOT_ZONES = {
    // item_1 (smartphone): hero-local x=58, y=272, w=67, h=95
    [TutorialMissionTypeDto.RegisterInterestedRegionsAndThemes]: {
        left: 58,
        top: 272,
        width: 67,
        height: 95,
    },
    // item_2 (map): hero-local x=25, y=392, w=95, h=74
    [TutorialMissionTypeDto.SavePlaceList]: {
        left: 25,
        top: 392,
        width: 95,
        height: 74,
    },
    // item_3 (magnifier): hero-local x=285, y=337, w=72, h=87
    [TutorialMissionTypeDto.UpvoteAccessibility]: {
        left: 285,
        top: 337,
        width: 72,
        height: 87,
    },
    [TutorialMissionTypeDto.ViewTutorialImages]: {
        left: 285,
        top: 337,
        width: 72,
        height: 87,
    },
};
export default function MissionHero({ hiddenActive, hiddenCompleted, onHiddenPress, imageWidth, heroImageUrl, bubbleVariant, bubbleFloat, mainMissionTypes, onMissionItemPress, onBubblePress, }) {
    const scale = imageWidth / DESIGN_WIDTH;
    const heroHeight = DESIGN_HEIGHT * scale;
    const px = (val) => val * scale;
    return (_jsxs(HeroContainer, { style: { width: imageWidth, height: heroHeight }, children: [_jsx(SccRemoteImage, { imageUrl: heroImageUrl, style: {
                    width: imageWidth,
                    height: heroHeight,
                }, resizeMode: "cover", wrapperBackgroundColor: null }), hiddenActive && !hiddenCompleted && (_jsx(HatHotZone, { elementName: "tutorial_mission_hat_hot_zone", onPress: onHiddenPress, style: {
                    position: 'absolute',
                    left: px(HAT_HOT_ZONE.left),
                    top: px(HAT_HOT_ZONE.top),
                    width: px(HAT_HOT_ZONE.width),
                    height: px(HAT_HOT_ZONE.height),
                } })), onMissionItemPress &&
                mainMissionTypes.map((missionType, idx) => {
                    const zone = MISSION_ITEM_HOT_ZONES[missionType];
                    if (!zone) {
                        return null;
                    }
                    return (_jsx(MissionItemHotZone, { 
                        // elementName 은 **순서 기반을 의도적으로 유지**한다. 미션 타입 기반으로
                        // 바꾸면 이름이 정확해지는 대신 기존 v1 대시보드의 시계열이 끊긴다.
                        // 대신 v1/v2 가 같은 이름에 서로 다른 미션을 매핑하므로(v1 item_1=스마트폰,
                        // v2 item_1=돋보기) **코호트를 나눠 보려면 logParams 의 mission_type 을 써야
                        // 한다.** 두 셋이 공존하는 기간에는 elementName 만으로 집계하면 섞인다.
                        elementName: `tutorial_mission_item_${idx + 1}_hot_zone`, logParams: { mission_type: missionType }, onPress: () => onMissionItemPress(missionType), style: {
                            position: 'absolute',
                            left: px(zone.left),
                            top: px(zone.top),
                            width: px(zone.width),
                            height: px(zone.height),
                        } }, missionType));
                }), bubbleVariant && (_jsx(SpeechBubble, { variant: bubbleVariant, heroWidth: imageWidth, float: bubbleFloat, onPress: onBubblePress }))] }));
}
const HeroContainer = styled.View `
  overflow: hidden;
`;
const HatHotZone = styled(SccPressable) ``;
const MissionItemHotZone = styled(SccPressable) ``;
